import React from 'react'
import PropTypes from 'prop-types'

export function MainInner (props) {
  return (
    <div className='main-inner py-2 py-lg-4 px-0 px-lg-2'>
      <div className={`container${props.fluid ? '-fluid' : ''}`}>
        {props.children}
      </div>
    </div>
  )
}

MainInner.defaultProps = {
  fluid: false
}

MainInner.propTypes = {
  children: PropTypes.node.isRequired,
  fluid: PropTypes.bool
}
